<script>
import EventSession from '@components/List/EventSession'
import EventTabList from '@components/List/EventTabList'
import FileTable from '@components/List/FileTable'
import { eventIsCanRegister } from '@utils/zerone-event'
import { eventSessionBigButtonStatusItem } from '@utils/zerone-event-status'
import { FAKE_EVENT_ITEM } from '@src/config/fake-evnet'

export default {
  components: {
    EventSession,
    FileTable,
    EventTabList,
  },
  props: {
    pageType: {
      type: String,
      default: '',
    },
    eventItem: {
      type: Object,
      default: () => {
        return FAKE_EVENT_ITEM
      },
    },
  },
  computed: {
    isCanRegister() {
      return eventIsCanRegister({ ...this.eventItem })
    },
    sessionBigButtonStatusItem() {
      return eventSessionBigButtonStatusItem({
        ...this.eventItem,
      })
    },
    showSessionFixed() {
      return true
    },
  },
  methods: {
    onApply({ sessionUuids }) {
      if (this.eventItem.registrationType === 'impartial') {
        const uuid = () => {
          const getIsEventList = this.eventItem.sessions.map((item) => {
            return item.sessions.filter((item2) => {
              return item2.isEvent
            })
          })

          const reduceIsEventList = getIsEventList.reduce((prev, curr) => {
            return [...prev, ...curr]
          })

          return reduceIsEventList.map((item) => {
            return item.uuid
          })
        }

        if (uuid()[0]) {
          this.$emit('apply', {
            sessionUuids: uuid(),
          })
        }
      }

      if (this.eventItem.registrationType === 'partial') {
        this.$emit('apply', {
          sessionUuids,
        })
      }
    },
  },
}
</script>
<template>
  <section :class="$style.ItemMultiple">
    <div :class="$style.sectionCourseList" class="section">
      <div class="container">
        <BaseSectionTitle :title="`${eventItem.categoryTitle || '活動'}場次`" class="text-center" />
        <EventTabList :event-item="eventItem" :session-list="eventItem.sessions" @apply="onApply" />
        <BaseButton
          v-if="sessionBigButtonStatusItem.display && eventItem.registrationType === 'impartial'"
          :class="sessionBigButtonStatusItem.class"
          class="courseSession__btn isFull"
          :disabled="sessionBigButtonStatusItem.disabled"
          @click="onApply"
        >
          {{ sessionBigButtonStatusItem.title }}
        </BaseButton>
      </div>
    </div>
    <template v-if="!!eventItem.description">
      <div :class="$style.sectionIntro" class="section">
        <div class="container">
          <BaseSectionTitle :title="`${eventItem.categoryTitle || '活動'}說明`" class="text-center" />
          <div class="text-gray-6 content" v-html="eventItem.description"></div>
        </div>
      </div>
    </template>
    <template v-if="!!eventItem.files[0]">
      <div class="section bg-gray-2">
        <div class="container">
          <BaseSectionTitle :title="`${eventItem.categoryTitle || '活動'}檔案下載`" class="text-center" />
          <FileTable type="download" :list="eventItem.files" class="isStyleEvent" />
        </div>
      </div>
    </template>
    <template v-if="!!eventItem.sponsors[0]">
      <div :class="$style.sectionSponsor" class="section">
        <div class="container">
          <BaseSectionTitle title="贊助與合作單位" class="text-center" />
          <div class="sponsor">
            <div class="row">
              <div v-for="(sponsorItem, index) in eventItem.sponsors" :key="`sponsorItem-${index}`" class="col-lg-2 col-sm-4 col-6 justify-content-center text-center">
                <div class="sponsor__item">
                  <a :href="sponsorItem.link" target="_blank">
                    <img :src="sponsorItem.logo" :alt="sponsorItem.title" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="sessionBigButtonStatusItem.display && eventItem.registrationType === 'impartial'">
      <div :class="$style.sessionFixed" class="d-md-block d-none">
        <BaseButton :class="sessionBigButtonStatusItem.class" class="sessionFixed__fixedBtn isFull" :disabled="sessionBigButtonStatusItem.disabled" @click="onApply">
          {{ sessionBigButtonStatusItem.title }}
        </BaseButton>
      </div>
    </template>
  </section>
</template>

<style lang="scss" module>
.sectionCourseList {
  background-color: $color-gray-2;

  :global {
    .sectionCourseList {
    }
  }
}

.sectionSponsor {
  :global {
    .sectionSponsor {
    }
  }
}

.sectionIntro {
  :global {
    .content {
      line-height: 2;
    }
  }
}

.sessionFixed {
  position: fixed;
  bottom: 0;
  z-index: 3;
  width: 100%;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 20px rgba(70, 73, 75, 0.15);

  :global {
    .sessionFixed {
      &__fixedBtn {
      }
    }
  }
}
</style>
